import { useState } from "react";
import { useAuth } from "../../../../contexts/AuthContext";
import server from "../../../../apis/server";
import Input from "../../../UI/Input/Input";
import Button from "../../../UI/Button/Button";
import ReactQuill from "react-quill-new";

import classes from "./AddMinistry.module.scss";

const AddMinistry = ({
  ministryFromList,
  clearSelectedMinistry,
  ministries,
  setMinistries,
  setSelectedRows,
}) => {
  const { authUser } = useAuth();

  console.log("ministryFromList in AddMinistry:", ministryFromList);

  const [messageStatus, setMessageStatus] = useState();
  const [saveEnabled, setSaveEnabled] = useState(null);
  const [selectedMinistry, setSelectedMinistry] = useState(
    ministryFromList ? ministryFromList : null,
  );

  const [descriptionValue, setDescriptionValue] = useState(
    ministryFromList ? ministryFromList.description : "",
  );

  const [ministryForm, setMinistryForm] = useState({
    name: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "Ministry name",
      },
      value: selectedMinistry ? selectedMinistry.name : "",
      validation: {
        required: true,
      },
      width: "100%",
    },
    description: {
      elementType: "richtext",
    },
    primaryContact: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "Primary contact name",
      },
      value: selectedMinistry ? selectedMinistry.primaryContact : "",
      validation: {
        required: false,
      },
      width: "100%",
    },
    primaryContactEmail: {
      elementType: "input",
      elementConfig: {
        type: "email",
        placeholder: "Primary contact email",
      },
      value: selectedMinistry ? selectedMinistry.primaryContactEmail : "",
      validation: {
        required: false,
      },
      width: "100%",
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessageStatus(1); // Set to "Saving..."

    const formValues = {
      name: ministryForm.name.value,
      description: descriptionValue,
      primaryContact: ministryForm.primaryContact.value,
      primaryContactEmail: ministryForm.primaryContactEmail.value,
      orgId: authUser.orgId,
    };

    try {
      let response;

      if (selectedMinistry && selectedMinistry.id) {
        // MODE: EDIT
        response = await server.put(
          `/ministries/update/${selectedMinistry.id}`,
          formValues,
        );
      } else {
        // MODE: ADD
        response = await server.post(
          `/ministries/add/${authUser.orgId}`,
          formValues,
        );
      }

      if (response.status === 200) {
        setMessageStatus(2); // Success!
      }
    } catch (error) {
      console.error("Save Error:", error);
      setMessageStatus(3); // Error
    }
  };

  const formElementsArray = [];
  for (let key in ministryForm) {
    formElementsArray.push({
      id: key,
      config: ministryForm[key],
    });
  }

  const form = (
    <form onSubmit={handleSubmit}>
      {formElementsArray.map((formElement) => {
        if (formElement.config.elementType === "richtext") {
          return (
            <ReactQuill
              theme="snow"
              value={descriptionValue}
              onChange={(content) => {
                setDescriptionValue(content);
                setSaveEnabled(true);
              }}
              key={formElement.id}
              className={classes.AddMinistry__Quill}
            />
          );
        } else
          return (
            <Input
              key={formElement.id}
              elementType={formElement.config.elementType}
              elementConfig={formElement.config.elementConfig}
              value={formElement.config.value}
              width={formElement.config.width}
              changed={(e) => {
                const updatedForm = { ...ministryForm };
                updatedForm[formElement.id].value = e.target.value;
                setMinistryForm(updatedForm);
              }}
            />
          );
      })}
      <Button type="submit">
        <>{selectedMinistry ? "Update Ministry" : "Add Ministry"}</>
      </Button>
    </form>
  );

  return (
    <div className={classes.AddMinistry}>
      <div>
        <h1>{selectedMinistry ? "Edit Ministry" : "Add Ministry"}</h1>
        {form}
      </div>
    </div>
  );
};

export default AddMinistry;
